import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslations from "./locales/en.json";
import skTranslations from "./locales/sk.json";
import deTranslations from "./locales/de.json";
import ruTranslations from "./locales/ru.json";
import ukTranslations from "./locales/uk.json";

const resources = {
  en: {
    translation: enTranslations,
  },
  sk: {
    translation: skTranslations,
  },
  de: {
    translation: deTranslations,
  },
  ru: {
    translation: ruTranslations,
  },
  uk: {
    translation: ukTranslations,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    debug: false,

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
  });

export default i18n;
